/* 
Model defined for Maintaining User Requests. It can also be used for transferring model
*/

export class UserRequestModel {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    mobile: string;
    roleIds: <Array>() => any;
    address: string;
    state: string;
    city: string;
    country: string;
    cdpRole: string;
    department: string;
    pinCode: string;
    branchId: string;
    thirdPartyUserId: number;
    constructor(
        email: string,
        password: string,
        firstName: string,
        lastName: string,
        mobile: string,
        roleIds: <Array>() => any,
        address: string,
        state: string,
        city: string,
        country: string,
        pinCode: string,
        branchId: string,
        cdpRole: string,
        department: string,
    ) {
        this.email = email;
        this.password = password;
        this.firstName = firstName;
        this.lastName = lastName;
        this.mobile = mobile;
        this.roleIds = roleIds;
        this.address = address;
        this.state = state;
        this.city = city;
        this.country = country;
        this.pinCode = pinCode;
        this.branchId = branchId;
        this.cdpRole = cdpRole;
        this.department = department;
    }
}

export class UserRequestUpdateModel {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    mobile: string;
    photo: string;
    constructor(
        email: string,
        password: string,
        firstName: string,
        lastName: string,
        mobile: string,
        photo: string,
    ) {
        this.email = email;
        this.password = password;
        this.firstName = firstName;
        this.lastName = lastName;
        this.mobile = mobile;
        this.photo = photo;
    }
}
export class UserStatusUpdateModel {
    status: string;
    id: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/user/UserRequestModel.ts